import { render, staticRenderFns } from "./SitesAdd.vue?vue&type=template&id=32504b2a"
import script from "./SitesAdd.vue?vue&type=script&lang=ts"
export * from "./SitesAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports